import {
  Box,
  Grid,
  TextField,
  createTheme,
  ThemeProvider,
  Menu,
  Stack,
  Select,
  Card,
  CardContent,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { useNavigate } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import MUIDataTable from "mui-datatables";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import HelpIcon from "@mui/icons-material/Help";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import StatusAlert from "../../../StatusAlertList/StatusAlert";
import ReactQuill from "react-quill";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import DatePicker from "../../../Components/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import HeaderAppreciation from "./HeaderAppreciation";
import { DialogActions } from "@mui/material";
import { useSelector } from "react-redux";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Appreciation() {
  const [open, setOpen] = React.useState(false);
  const userPermissions = useSelector((state) => state?.user?.permissions);
  const [award, setAward] = React.useState("");
  const [givenTo, setGivenTo] = React.useState("");
  const [date, setDate] = React.useState(null);
  const [awardError, setAwardError] = React.useState(false);

  const [summary, setSummary] = useState("");
  const [photo, setPhoto] = useState("");

  const [updateGivenTo, setUpdateGivenTo] = React.useState("");
  const [updateAward, setUpdateAward] = React.useState("");
  const [updateSummary, setUpdateSummary] = React.useState("");
  const [updatePhoto, setUpdatePhoto] = React.useState("");

  const [updateDate, setUpdateDate] = React.useState("");
  const [updateGivenToError, setUpdateGivenToError] = React.useState("");
  const [updateAwardError, setUpdateAwardError] = React.useState("");
  const [updateDateError, setUpdateDateError] = React.useState("");
  const [data, SetData] = useState([]);
  const [appreciationData, setAppreciationData] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [update, setUpdate] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  const navigate = useNavigate();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const handleClickUpdate = () => {
    setUpdate(true);
  };
  const handleViewMore = async () => {
    const result = await fetch(
      `https://rptpl.roadpilot.co.in/public/api/GetKnowledagebaseById/${openMenuId}`,
      {
        method: "POST",
      }
    );
    const rowData = await result.json();
    navigate(`/hr/appreciation/${openMenuId}`, { state: rowData });
  };
  const handleUpdateClose = () => {
    setUpdate(false);
  };
  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };
  async function getData() {
    let results = await fetch(
      "https://rptpl.roadpilot.co.in/public/api/getTaxSettings"
    );
    results = await results.json();
    setAppreciationData(results.data);
  }
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openDropMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const columns = [
    {
      name: "",
      label: "Given To", // to rename column
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Given To
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "",
      label: "Award Name",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Award Name
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "",
      label: "Given On",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Given On
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "id", // Assuming this is the name of the column containing the ID
      label: "Action",

      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right", // Aligns header to the left
                paddingRight: "35px", // Add padding for starting point
                borderBottom: "1px solid #ddd",
              }}
            >
              Action
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => (
          <>
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "flex-end", // Aligns content to the left
                alignItems: "center",
                paddingRight: "5px", // Add padding for starting point
              }}
            >
              <div style={{ paddingRight: "5px" }}>
                <Button
                  id="basic-button"
                  aria-controls={openDropMenu ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openDropMenu ? "true" : undefined}
                  onClick={handleClick}
                >
                  <div onClick={() => handleOpenMenu(value)}>
                    <MoreHorizTwoToneIcon />
                  </div>
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={openDropMenu}
                  onClose={handleCloseMenu}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  {userPermissions?.hr_appreciation_view !== 0 && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => handleViewMore(tableMeta.rowData)}
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <RemoveRedEyeIcon /> View More
                      </div>
                    </MenuItem>
                  )}
                  {userPermissions?.hr_appreciation_update !== 0 && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => handleEdit(value)}
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <EditNoteIcon /> Edit
                      </div>
                    </MenuItem>
                  )}
                  {userPermissions?.hr_appreciation_delete !== 0 && (
                    <MenuItem onClick={handleCloseMenu}>
                      <div
                        onClick={() => handleDelete(value)}
                        style={{
                          display: "flex",
                          justifyContent: "space-center",
                          alignItems: "center",
                        }}
                      >
                        <DeleteForeverIcon /> Delete
                      </div>
                    </MenuItem>
                  )}
                </Menu>
              </div>
            </div>
          </>
        ),
      },
    },
  ];
  async function handleEdit(id) {
    const result = appreciationData.filter((item) => item.id === id);
    SetData(result[0]);

    handleClickUpdate();
  }
  useEffect(() => {
    setUpdateGivenTo(data.givenTo);
  }, [data.givenTo]);

  useEffect(() => {
    setUpdateAward(data.award);
  }, [data.award]);
  useEffect(() => {
    setUpdateAwardError(data.awardError);
  }, [data.awardError]);
  useEffect(() => {
    setUpdateDate(data.date);
  }, [data.date]);
  useEffect(() => {
    setUpdatePhoto(data.photo);
  }, [data.photo]);
  useEffect(() => {
    setUpdateSummary(data.summary);
  }, [data.summary]);
  useEffect(() => {
    setUpdateGivenToError(data.givenToError);
  }, [data.givenToError]);

  async function UpdateData(id) {
    const formData = new FormData();

    formData.append("givenTo", updateGivenTo);
    formData.append("date", updateDate);
    formData.append("dateError", updateDateError);
    formData.append("award", updateAward);
    formData.append("photo", updatePhoto);
    formData.append("summary", updateSummary);
    formData.append("givenToError", updateGivenToError);
    formData.append("awardError", updateAwardError);
    try {
      let response = await fetch(
        `https://rptpl.roadpilot.co.in/public/api/updateTaxSettings/${data.id}`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update data");
      }

      handleUpdateClose();

      showAlert("  Updated successfully", "success");
    } catch (error) {
      console.error(error);
      showAlert("Failed to update business location", "error");
    }
  }

  async function handleDelete(id) {
    const response = await fetch(
      "https://rptpl.roadpilot.co.in/public/api/deleteTaxSettings/" + id,
      {
        method: "DELETE",
      }
    );

    if (response.ok) {
      getData();
      showAlert("Tax Data Deleted Successfully!", "warning");
    } else {
      showAlert("Tax Data Deleted failed!", "error");
    }
  }

  // Save Lead Sourse
  const item = {
    award,
    givenTo,
    photo,
    summary,
    date,
  };
  async function SaveData() {
    try {
      const response = await fetch(
        `https://rptpl.roadpilot.co.in/public/api/addTaxSettings`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(item),
        }
      );

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      showAlert("Tax Data Added Successfully!", "success");
      getData();
      setOpen(false);
    } catch (error) {
      console.error("Fetch error:", error);
      showAlert("Failed to add tax data", "error");
    }
  }

  const handleDateChange = (newDate) => {
    setDate(newDate); // Update the date state
  };

  const handleChange = (value) => {
    setSummary(value); // Update the state with the new value
  };

  const handlePhoto = (e) => {
    const file = e.target.files[0];
    setPhoto(file.name);
  };

  const handleSave = () => {
    const list = { award, givenTo, date, summary, photo };

    if (award === "") {
      setAwardError(true);
    } else {
      const list = { award, givenTo, date, summary, photo };

      setAwardError(false); // Reset the error state
      handleClose(); // Close the dialog
    }
  };

  const options = {
    selectableRows: "none",
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 25, 100],
    tableBody: {
      style: {
        maxHeight: "500px",
        overflowY: "scroll",
        marginLeft: "5PX",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
      },
    },
    rows: {
      style: {
        marginLeft: "5px",
        textAlign: "center",
      },
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  // Define reusable input styling to match RecJobs style
  const inputProps = {
    sx: {
      bgcolor: "#f9f9f9",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#e0e0e0",
        },
        "&:hover fieldset": {
          borderColor: "#bdbdbd",
        },
      },
      "& .MuiSelect-select": {
        color: "#424242", // For dropdown selects
      },
      "& .MuiInputBase-input": {
        color: "#424242", // For text and date inputs
      },
    },
  };

  const checkboxStyle = {
    color: "#9e9e9e",
    "&.Mui-checked": {
      color: "#4285F4",
    },
  };

  return (
    <>
      <HeaderAppreciation />
      <React.Fragment>
        <Dialog
          fullWidth
          maxWidth="lg"
          open={update}
          onClose={handleUpdateClose}
          TransitionComponent={Transition}
          PaperProps={{
            style: {
              position: "absolute",
              top: 0,
              right: 0,
              width: "calc(100% - 260px)", // Adjusted width to account for sidebar
              height: "100%",
              backgroundColor: "white",
              margin: 0,
              maxHeight: "100%",
              borderRadius: 0,
              overflowX: "hidden",
              zIndex: 1200,
            },
          }}
        >
          <AppBar sx={{ position: "relative", bgcolor: "#ffffff", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleUpdateClose}
                aria-label="close"
                sx={{ color: "#212121" }}
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: "#212121" }} component="div">
                Update Appreciation
              </Typography>
            </Toolbar>
          </AppBar>
          <Box
            sx={{
              padding: "30px",
              margin: "20px",
              backgroundColor: "white",
            }}
          >
            <Typography
              sx={{ ml: 2, flex: 1, color: "black", fontSize: "20px" }}
              component="div"
            >
              Assign Appreciation
            </Typography>
            <hr sx={{ color: "gray" }} />

            <Grid
              container
              spacing={2}
              sx={{ marginTop: "20px", padding: "20px" }}
            >
              <Stack direction="row" sx={{ width: "100%" }}>
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={4}
                  sx={{ paddingRight: { xs: 0, sm: 2 } }}
                >
                  <Stack direction="column">
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Award <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Select
                      value={updateAward}
                      autoFocus
                      onChange={(e) => setUpdateAward(e.target.value)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>
                      <MenuItem value={"Gold"}>Gold</MenuItem>
                      <MenuItem value={"Silver"}>Silver</MenuItem>
                      <MenuItem value={"Bronze"}>Bronze</MenuItem>
                    </Select>
                    {updateAwardError && (
                      <Typography variant="caption" style={{ color: "red" }}>
                        Please select an award
                      </Typography>
                    )}
                  </Stack>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={4}
                  sx={{ paddingRight: { xs: 0, sm: 2 } }}
                >
                  <Stack direction="column">
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Given To<span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Select
                      value={updateGivenTo}
                      autoFocus
                      onChange={(e) => setUpdateGivenTo(e.target.value)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      sx={{
                        border: "1px solid black",
                        boxSizing: "border-box",
                        "& .MuiOutlinedInput-root": {
                          borderColor: "black !important",
                          "&:hover fieldset": {
                            borderColor: "black !important",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "black !important",
                          },
                        },
                        color: "black",
                      }}
                    >
                      <MenuItem disabled value="">
                        <em>---</em>
                      </MenuItem>
                      <MenuItem value={"Andrew"}>Andrew</MenuItem>
                      <MenuItem value={"Bohr"}>Bohr</MenuItem>
                      <MenuItem value={"Ceaser"}>Ceaser</MenuItem>
                    </Select>
                  </Stack>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={4}
                  sx={{ paddingRight: { xs: 0, sm: 2 } }}
                >
                  <Stack direction="column">
                    <Typography
                      variant="p"
                      gutterBottom
                      style={{ color: "black" }}
                    >
                      Date
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={["DatePicker"]}
                        onChange={(e) => handleDateChange(e.target.value)}
                        sx={{ marginTop: "-10px" }}
                      >
                        <DatePicker
                          value={updateDate}
                          onChange={handleDateChange}
                          sx={{
                            border: "1px solid black",
                            "& .MuiOutlinedInput-root": {
                              borderColor: "black !important",
                              color: "black !important",
                              "&:hover fieldset": {
                                borderColor: "black !important",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor: "black !important",
                              },
                            },
                            "& .MuiSvgIcon-root": {
                              color: "black",
                            },
                          }}
                        >
                          {(params) => (
                            <TextField {...params} variant="outlined" />
                          )}
                        </DatePicker>
                      </DemoContainer>
                    </LocalizationProvider>
                  </Stack>
                </Grid>
              </Stack>
            </Grid>

            <Grid container sx={{ padding: "20px" }}>
              <Stack direction="column" sx={{ width: "100%" }}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Summary<span style={{ color: "red" }}>*</span>
                </Typography>

                <ReactQuill
                  value={updateSummary}
                  onChange={handleChange}
                  // modules={modules}
                  // theme="snow"
                  style={{
                    // border: '1px solid black',
                    // borderRadius: '4px',
                    //padding: '10px',
                    width: "100%",
                    boxSizing: "border-box",
                    color: "black",
                    borderBlockColor: "black",
                    // minHeight: '100px' // Set your desired minimum height
                  }}
                />
              </Stack>
            </Grid>
            <Grid container sx={{ padding: "20px" }}>
              <Stack direction="column" sx={{ width: "100%" }}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Photo <HelpIcon></HelpIcon>
                </Typography>
                <label
                  htmlFor="file-upload"
                  style={{
                    cursor: "pointer",
                    color: "black",
                    border: "1px solid black",
                    borderRadius: "4px",
                    padding: "10px",
                    width: "100%",
                    boxSizing: "border-box",
                    minHeight: "100px", // Set your desired minimum height
                    backgroundColor: "lightgray", // Change background color to light gray
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Choose a File
                </label>
                <input
                  onChange={handlePhoto}
                  type="file"
                  id="file-upload"
                  style={{ display: "none" }}
                />
                {updatePhoto && <div style={{ color: "black" }}>{photo}</div>}
              </Stack>
            </Grid>

            <Button
              variant="contained"
              autoFocus
              color="inherit"
              onClick={UpdateData}
              sx={{
                backgroundColor: "blue",
                "&:hover": { backgroundColor: "orange" },
                textAlign: "center",
                margin: "25px",
              }}
            >
              Update
            </Button>
          </Box>
        </Dialog>
      </React.Fragment>
      <List style={{ background: "none", padding: 5 }}>
        <StatusAlert
          open={alertOpen}
          setOpen={setAlertOpen}
          message={alertMessage}
          severity={alertSeverity}
        />
        <ListItemText style={{ background: "none" }}>
          <React.Fragment>
            {userPermissions?.hr_appreciation_add !== 0 && (
              <Stack
                direction="row"
                spacing={2}
                sx={{ margin: "10px 0 5px 2px" }}
              >
                <Box
                  onClick={handleClickOpen}
                  sx={{
                    backgroundColor: "#4285F4",
                    "&:hover": { backgroundColor: "#3367D6" },
                    textAlign: "center",
                    padding: "10px",
                    marginLeft: "10px",
                    height: "40px",
                    width: "155px",
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    borderRadius: "4px",
                    fontSize: "15px",
                    fontFamily: "sans-serif",
                    cursor: "pointer",
                    color: "#fff",
                  }}
                >
                  <AddIcon />
                  Add Appreciation
                </Box>
              </Stack>
            )}
            <Dialog
              fullWidth
              maxWidth="lg"
              open={open}
              onClose={handleClose}
              TransitionComponent={Transition}
              PaperProps={{
                style: {
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: "calc(100% - 260px)", // Adjusted width to account for sidebar
                  height: "100%",
                  backgroundColor: "#f5f5f5",
                  margin: 0,
                  maxHeight: "100%",
                  borderRadius: 0,
                  overflowX: "hidden",
                  zIndex: 1200,
                },
              }}
            >
              <AppBar sx={{ position: "relative", bgcolor: "#ffffff", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)" }}>
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                    sx={{ color: "#212121" }}
                  >
                    <CloseIcon fontSize="large" />
                  </IconButton>
                  <Typography
                    sx={{ ml: 2, flex: 1, fontSize: "18px", color: "#212121" }}
                    component="div"
                  >
                    New Appreciation
                  </Typography>
                </Toolbar>
              </AppBar>
              <Box sx={{ background: "#f5f5f5", p: 4, overflowY: "auto" }}>
                <Card sx={{ p: 2, bgcolor: "#ffffff", boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)" }}>
                  <CardContent>
                    <Typography variant="h6" sx={{ color: "#212121", mb: 3 }}>
                      Add Appreciation
                    </Typography>
                    <Divider sx={{ mb: 3 }} />
                    
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={4}>
                        <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                          Award <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <TextField
                          select
                          fullWidth
                          value={award}
                          size="small"
                          onChange={(e) => setAward(e.target.value)}
                          InputProps={inputProps}
                        >
                          <MenuItem disabled value="">
                            <em>---</em>
                          </MenuItem>
                          <MenuItem value={"Gold"}>Gold</MenuItem>
                          <MenuItem value={"Silver"}>Silver</MenuItem>
                          <MenuItem value={"Bronze"}>Bronze</MenuItem>
                        </TextField>
                        {awardError && (
                          <Typography
                            variant="caption"
                            style={{ color: "red" }}
                          >
                            Please select an award
                          </Typography>
                        )}
                      </Grid>
                      
                      <Grid item xs={12} md={4}>
                        <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                          Given To <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <TextField
                          select
                          fullWidth
                          value={givenTo}
                          size="small"
                          onChange={(e) => setGivenTo(e.target.value)}
                          InputProps={inputProps}
                        >
                          <MenuItem disabled value="">
                            <em>---</em>
                          </MenuItem>
                          <MenuItem value={"Andrew"}>Andrew</MenuItem>
                          <MenuItem value={"Bohr"}>Bohr</MenuItem>
                          <MenuItem value={"Ceaser"}>Ceaser</MenuItem>
                        </TextField>
                      </Grid>
                      
                      <Grid item xs={12} md={4}>
                        <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                          Date
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={date}
                            onChange={handleDateChange}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                size: "small",
                                InputProps: inputProps
                              }
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                          Summary <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <Box sx={{ 
                          border: "1px solid #e0e0e0", 
                          borderRadius: "4px", 
                          bgcolor: "#f9f9f9", 
                          ".quill": { bgcolor: "#f9f9f9" } 
                        }}>
                          <ReactQuill
                            value={summary}
                            onChange={handleChange}
                            style={{
                              width: "100%",
                              boxSizing: "border-box",
                              color: "#424242",
                              backgroundColor: "#f9f9f9",
                              minHeight: "150px",
                            }}
                          />
                        </Box>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
                          Photo
                        </Typography>
                        <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}>
                          <label
                            htmlFor="file-upload"
                            style={{
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "100%",
                              padding: "8px",
                              backgroundColor: "#f9f9f9",
                              border: "1px solid #e0e0e0",
                              borderRadius: "4px",
                              color: "#424242",
                            }}
                          >
                            Choose a File
                          </label>
                          <input
                            onChange={handlePhoto}
                            type="file"
                            id="file-upload"
                            style={{ display: "none" }}
                          />
                        </Box>
                        {photo && (
                          <Typography variant="caption" sx={{ color: "#4285F4", mt: 1 }}>
                            {photo}
                          </Typography>
                        )}
                      </Grid>
                    </Grid>

                    <Box display="flex" gap={2} mt={3}>
                      <Button
                        onClick={SaveData}
                        variant="contained"
                        sx={{
                          bgcolor: "#4285F4",
                          color: "white",
                          "&:hover": { bgcolor: "#3367D6" },
                          fontWeight: 500,
                          textTransform: "none",
                          padding: "8px 16px",
                        }}
                      >
                        Add
                      </Button>
                      <Button
                        onClick={handleClose}
                        variant="outlined"
                        sx={{
                          borderColor: "#bdbdbd",
                          color: "#424242",
                          "&:hover": {
                            borderColor: "#9e9e9e",
                            bgcolor: "rgba(0, 0, 0, 0.04)",
                          },
                          textTransform: "none",
                          padding: "8px 16px",
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Box>
            </Dialog>
          </React.Fragment>
        </ListItemText>
        
        <Divider />
        <ListItemText style={{ background: "white", margin: 0, width: "100%" }}>
          <ThemeProvider theme={getTheme()}>
            <MUIDataTable
              title={
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: "1.5rem",
                    color: "#333",
                  }}
                >
                  Appreciation Lists
                </span>
              }
              data={appreciationData}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </ListItemText>
      </List>
    </>
  );
}

export default Appreciation;
